<template>
  <div class="card_field">
    <div
      class="card_filed_con"
      :class="{
        local_cvc: true,
        red: local_input == 'red',
        green: local_input == 'green',
        blue: local_input == 'blue',
      }"
      @click="focusCvvInput"
    >
      <p class="card_input_label">{{ $t('primer.cvv') }}*</p>
      <p class="card_input_content" :id="primerCvvID"></p>
      <img v-if="local_input != 'green'" class="card_show" src="@img/primer/cardcvv.png" />
      <img class="card_show cardok" v-else src="@img/icon_primer_ok.png" />
    </div>
    <p class="errortext" v-show="local_input_errortext != '' && local_input == 'red'">
      {{ local_input_errortext }}
    </p>
  </div>
</template>
<script>
let id = 0
function getPrimerCvvID() {
  return `primary-cvv-${id++}`
}
export default {
  props: {
    cardInfo: {
      type: Object,
      default: () => {},
      required: true,
    },
    vaultManager: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      primerCvvID: getPrimerCvvID(),
      selcvvInput: null,
      local_input: '',
      local_input_errortext: '',

      rootFont: 0,
    }
  },
  created() {
    this.rootFont = parseFloat(document.documentElement.style.fontSize)
  },
  mounted() {
    this.createPrimerCvv()
  },
  methods: {
    async createPrimerCvv() {
      this.selcvvInput = await this.vaultManager.createCvvInput({
        cardNetwork: this.cardInfo.paymentInstrumentData.network,
        container: `#${this.primerCvvID}`,
        name: 'cvv',
        placeholder: this.$t('primer.number'),
        style: {
          height: '100%',
          input: {
            base: {
              lineHeight: `${(0.48 * this.rootFont).toFixed(4)}px`,
              height: `${(0.48 * this.rootFont).toFixed(4)}px`,
              color: '#000000',
              fontSize: `${(0.4 * this.rootFont).toFixed(4)}px`,
              textAlign: this.$i18n.locale === 'AR' ? 'right' : 'left',
              fontWeight: 500,
              fontFamily:
                '"roboto-medium", -apple-system, BlinkMacSystemFont, "Segoe UI", Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
              placeholder: {
                color: '#9D9D9D',
                fontWeight: 400,
                fontFamily:
                  '"roboto-regular", -apple-system, BlinkMacSystemFont, "Segoe UI", Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
              },
            },
          },
        },
      })
      this.selcvvInput.addEventListener('change', () => {
        const ans = this.updateValidateStatus()
        if (!ans) {
          this.local_input = 'blue'
        } else {
          this.local_input = 'green'
        }
      })
      this.selcvvInput.addEventListener('blur', () => {
        this.updateValidateStatus()
      })
    },
    focusCvvInput() {
      if (!this.selcvvInput) return
      this.selcvvInput.focus()
    },
    updateValidateStatus() {
      if (this.selcvvInput.metadata.error) {
        this.local_input = 'red'
        if (this.selcvvInput.metadata.error == 'CVV number is required') {
          this.local_input_errortext = this.$t('primer.empty')
        } else {
          this.local_input_errortext = this.$t('primer.error')
        }
        return false
      } else {
        this.local_input = 'green'
        this.local_input_errortext = ''
        return true
      }
    },
    validate() {
      let valid = true
      if (this.selcvvInput.metadata.error) {
        this.local_input = 'red'
        if (this.selcvvInput.metadata.error == 'CVV number is required') {
          this.local_input_errortext = this.$t('primer.empty')
        } else {
          this.local_input_errortext = this.$t('primer.error')
        }
        valid = false
      } else {
        this.local_input = 'green'
        this.local_input_errortext = ''
      }
      return {
        valid,
        value: this.selcvvInput.valueToken,
      }
    },
  },
  beforeDestroy() {
    this.selcvvInput.remove && this.selcvvInput.remove()
  },
}
</script>
<style lang="less">
@import '../../cardField.less';
</style>
